import { Fragment, useState } from "react";
import { useAuth } from "../../../contexts/AuthProvider";
import SystemDialog from "../../UIToolkit/Popups/Dialog";
import SystemButton from "../../UIToolkit/SystemButton/SystemButton";
import { useCreateUsersForDepartment, useMissingUsersCount } from "../hooks";
import { CreateMissingUsersSummaryPopup } from "./CreateMissingUsersSummaryPopup";

export const CreateMissingUsersButton = () => {
	const { userInfo } = useAuth();
	const { mutateAsync: createMissingUsers, isPending: createMissingUsersLoading, data, isSuccess, reset } = useCreateUsersForDepartment();
	const { data: missingUsersCount } = useMissingUsersCount();
	const [confirmOpen, setConfirmOpen] = useState(false);

	if (!userInfo?.support) {
		return null;
	}

	const handleCreateMissingUsersClick = () => {
		setConfirmOpen(true);
	};

	const handleConfirm = async () => {
		setConfirmOpen(false);
		await createMissingUsers();
	};

	return (
		<Fragment>
			{isSuccess && !!data && <CreateMissingUsersSummaryPopup data={data} onClose={() => reset()} />}
			<SystemDialog
				open={confirmOpen}
				onClose={() => setConfirmOpen(false)}
				title="Create Missing Users"
				body={`You are about to create ${missingUsersCount ?? "..."} user accounts. Are you sure?`}
				onConfirm={handleConfirm}
				confirmLoading={createMissingUsersLoading}
				confirmDisabled={missingUsersCount === 0}
			/>
			<SystemButton
				loading={createMissingUsersLoading}
				tooltip={createMissingUsersLoading ? "Creating missing users..." : undefined}
				onClick={handleCreateMissingUsersClick}
			>
				Create Missing Users
			</SystemButton>
		</Fragment>
	);
};
